import { Component, type OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { SystemNavBarComponent } from '@system/layout/nav-bar/system-nav-bar.component';
import { AuthService } from '@infra/auth/auth.service';

@Component({
  templateUrl: './page-not-found.component.html',
  imports: [SystemNavBarComponent, TranslatePipe],
})
export class PageNotFoundComponent implements OnInit {
  private readonly router = inject(Router);
  private readonly authService = inject(AuthService);

  request: string;

  ngOnInit(): void {
    this.request = this.router.url;
  }

  goToDashboard(): void {
    if (this.authService.isCompanyChosen) {
      this.router.navigate([`/company/${this.authService.companyUrlName}`]);
    } else if (this.authService.isGlobalAdmin) {
      this.router.navigate(['/admin']);
    }
  }
}
